import { generateClassName , getColorCSSVariable } from '@klv/shared/utils/functions';
import { Wrapper } from '@klv/utils/wrapper';

import * as styles from './styles/rip.module.scss';

import RipA from './svgs/rip-a-top';
import RipB from './svgs/rip-b-top';
import RipC from './svgs/rip-c-top';
import RipD from './svgs/rip-d-top';

import type { IRip } from './types';

export const Rip = ({
  className = '',
  backgroundColor,
  customPadding = { customPaddingBottom: 'xs', customPaddingTop: 'xs' },
  direction,
  orientation,
  ripColor,
  ripVariant,
}: IRip) => {
  return (
    <Wrapper contained={false} customPadding={customPadding}  backgroundColor={backgroundColor}>
      <div 
        className={generateClassName([className, styles.rip, styles[direction]])}
        style={{
          '--rip-color': getColorCSSVariable(ripColor),
          '--rip-orientation': orientation === 'original' ? 'scaleX(1)' : 'scaleX(-1)',
          '--rip-direction': direction === 'top' ? 'scaleY(1)' : 'scaleY(-1)',
        } as React.CSSProperties}
      > 
        {ripVariant === 'a' && <RipA />}
        {ripVariant === 'b' && <RipB />}
        {ripVariant === 'c' && <RipC />}
        {ripVariant === 'd' && <RipD />}

      </div>
    </Wrapper>
  );
};
